/* src/app/shared/components/flow-button/flow-button.component.scss */
:host {
  display: inline-flex;
  width: fit-content;
}
.flow-button {
  display: inline-flex;
  gap: 8px;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  border: none;
  outline: none;
  padding: 0 12px;
  position: relative;
  overflow: hidden;
  transition:
    background-color 0.2s,
    box-shadow 0.15s,
    transform 0.15s;
}
.flow-button img {
  width: 20px;
  height: 20px;
}
.flow-button:active {
  box-shadow:
    0 -2px 2px 0 rgba(0, 0, 0, 0.1) inset,
    0 2px 2px 0 rgba(255, 255, 255, 0.1) inset,
    0 0 3px rgba(0, 0, 0, 0.15);
  transform: translateY(1px);
}
.flow-button.primary {
  background-color: #3753be;
  color: white;
}
.flow-button.primary img {
  filter: brightness(0) invert(1);
}
.flow-button.primary p {
  color: white !important;
}
.flow-button.primary:hover {
  background-color: #4568d0;
}
.flow-button.primary:focus-visible {
  border: 1px solid #4568d0;
  box-shadow:
    0 1px 3px rgba(0, 0, 0, 0.2),
    0 0 0 1px #fff,
    0 0 0 3px rgba(89, 113, 197, 0.5) !important;
}
.flow-button.secondary {
  background-color: #f4f4f5;
  color: #18181b;
  border: 1px solid #e4e4e7;
}
.flow-button.secondary img {
  filter: brightness(0) saturate(100%) invert(13%);
}
.flow-button.secondary:hover {
  background-color: #e4e4e7;
}
.flow-button.secondary:focus-visible {
  border: 1px solid #4568d0;
  box-shadow:
    0 1px 3px rgba(0, 0, 0, 0.2),
    0 0 0 1px #fff,
    0 0 0 3px rgba(89, 113, 197, 0.5) !important;
}
.flow-button.tertiary {
  background-color: transparent;
  border: 1px solid transparent;
  color: #18181b;
  box-shadow: none;
}
.flow-button.tertiary img {
  filter: brightness(0) saturate(100%) invert(13%);
}
.flow-button.tertiary:hover {
  background-color: #fafafa;
}
.flow-button.tertiary:focus-visible {
  border: 1px solid #4568d0;
  box-shadow:
    0 1px 3px rgba(0, 0, 0, 0.2),
    0 0 0 1px #fff,
    0 0 0 3px rgba(89, 113, 197, 0.5) !important;
}
.flow-button.destructive {
  background-color: #dc2626;
  color: white;
}
.flow-button.destructive img {
  filter: brightness(0) invert(1);
}
.flow-button.destructive p {
  color: white !important;
}
.flow-button.destructive:hover {
  background-color: #b91c1c;
}
.flow-button.destructive:focus-visible {
  border: 1px solid #4568d0;
  box-shadow:
    0 1px 3px rgba(0, 0, 0, 0.2),
    0 0 0 1px #fff,
    0 0 0 3px rgba(89, 113, 197, 0.5) !important;
}
.flow-button.disabled {
  background-color: #e4e4e7 !important;
  cursor: default !important;
  color: #d4d4d8 !important;
  box-shadow: none !important;
}
.flow-button.disabled img {
  filter: brightness(0) saturate(100%) invert(87.5%);
}
.flow-button.disabled p {
  color: #d4d4d8 !important;
}
.flow-button.disabled:hover {
  background-color: #e4e4e7 !important;
}
.flow-button.disabled:focus-visible {
  box-shadow: none;
}
.flow-button.disabled:active {
  box-shadow: none !important;
  transform: translateY(0) !important;
}
.flow-button.large {
  padding: 0 16px;
  height: 56px;
  border-radius: 16px;
}
.flow-button.medium {
  padding: 0 12px;
  height: 48px;
  border-radius: 12px;
}
.flow-button.small {
  padding: 0 12px;
  height: 40px;
  border-radius: 12px;
}
.flow-button.tiny {
  padding: 0 4px;
  height: 32px;
  border-radius: 8px;
}
.flow-button.iconOnly {
  padding: 0 !important;
}
.flow-button.loading {
  cursor: default;
  pointer-events: none;
}
.flow-button .lds-ring {
  display: inline-block;
  position: relative;
  width: 20px;
  height: 20px;
}
.flow-button .lds-ring div {
  box-sizing: border-box;
  display: block;
  position: absolute;
  width: 20px;
  height: 20px;
  border: 1.5px solid #18181b;
  border-radius: 50%;
  animation: lds-ring 0.85s linear infinite;
  border-color: #18181b #18181b #18181b transparent;
}
.flow-button.primary .lds-ring div,
.flow-button.destructive .lds-ring div {
  border-color: #ffffff #ffffff #ffffff transparent;
}
@keyframes lds-ring {
  0% {
    transform: rotate(0deg);
  }
  100% {
    transform: rotate(360deg);
  }
}
@keyframes press-in {
  0% {
    box-shadow: 0 1px 4px 0 rgba(0, 0, 0, 0.12);
    transform: translateY(0);
  }
  100% {
    box-shadow:
      0 -2px 2px 0 rgba(0, 0, 0, 0.1) inset,
      0 2px 2px 0 rgba(255, 255, 255, 0.1) inset,
      0 0 3px rgba(0, 0, 0, 0.15);
    transform: translateY(1px);
  }
}
/*# sourceMappingURL=flow-button.component.css.map */
